module.exports = __webpack_public_path__ + "static/img/guelph3.01db00f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/guelph3.jpg
// module id = 92
// module chunks = 9